import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';

const RowIndexCellRenderer: React.FC<ICellRendererParams> = (props) => {
  if (props.node.rowIndex === null || props.node.rowIndex === undefined) {
    return null;
  }
  return <>{props.node.rowIndex + 1}</>;
};

export default RowIndexCellRenderer;
